import React, { useRef } from "react";
import { Handle, Position } from "reactflow";
import {
  Title,
  SubTitle,
  IconContainer,
} from "../../WorkflowViewerContent/workflowViewerContent.styles";
import WarningIcon from "@mui/icons-material/Warning";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  ConfigureContent,
  ContentContainer,
  NodeContainer,
  ConfigureNodeContainer,
} from "./node.styles";

type NodeProps = {
  id: string;
  targetPosition: string;
  sourcePosition: string;
  data: {
    Icon: any;
    title: string;
    subTitle: string;
    isConfigurable: boolean;
    onNodeClick?: (id: string) => void;
  };
};

export const Node: React.FC<NodeProps> = ({
  id,
  targetPosition,
  sourcePosition,
  data,
}) => {
  const [_, setForceRender] = React.useState(false);
  const ref = useRef(null);
  React.useEffect(() => {
    setForceRender((prevState) => !prevState);
  }, []);
  const { Icon, title, subTitle, isConfigurable, onNodeClick } = data;
  return (
    <NodeContainer
      isConfigurable={isConfigurable}
      onClick={() => onNodeClick && onNodeClick(id)}
      className={"nodrag"}
      ref={ref}
    >
      {id === "createAwaPerformanceInputData" && targetPosition !== "None" && (
        <Handle type="target" position={"left" as Position} id="b" />
      )}
      {targetPosition !== "None" &&
        targetPosition !== "createAwaPerformanceInputData" && (
          <Handle type="target" position={"top" as Position} id="c" />
        )}
      <IconContainer>{Icon}</IconContainer>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Title>{title}</Title>
        <SubTitle>{subTitle}</SubTitle>
      </div>
      <ContentContainer isConfigurable={isConfigurable}>
        {isConfigurable && (
          <WarningIcon
            width={"1rem"}
            height={"1rem"}
            sx={{ color: "#E7AA12", marginRight: "0.5rem" }}
          />
        )}
        <div>{isConfigurable ? "Task Not Configured" : "No Action Needed"}</div>
      </ContentContainer>
      {sourcePosition !== "None" && (
        <Handle type="source" position={sourcePosition as any} id="a" />
      )}
    </NodeContainer>
  );
};

export const ConfigureNode: React.FC<NodeProps> = ({
  id,
  targetPosition,
  sourcePosition,
  data,
}) => {
  return (
    <div onClick={() => data.onNodeClick} id={id}>
      {targetPosition !== "None" && (
        <Handle type="target" position={"right" as Position} />
      )}
      <ConfigureNodeContainer>
        <SettingsIcon sx={{ color: "white" }} />
        <ConfigureContent>WF Step 1: Configure</ConfigureContent>
      </ConfigureNodeContainer>
      {sourcePosition !== "None" && (
        <Handle type="source" position={"right" as Position} id="a" />
      )}
    </div>
  );
};
